import React, { useState } from 'react'
import Switch from 'react-switch'
import styled from 'styled-components'
import GenericTextSpan from './GenericTextSpan'

const LabelContainer = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4%;
`

const GenericSwitch = ({ text, handleChange, checked, defaultChecked }) => {
  return (
    <LabelContainer>
      <GenericTextSpan margin={'0 10px 0 0'}>{text}</GenericTextSpan>
      <Switch
        onColor={'#a1ff68'}
        offColor={'#342152'}
        onChange={handleChange}
        checked={defaultChecked | checked | false}
        checkedIcon={false}
        uncheckedIcon={false}
      />
    </LabelContainer>
  )
}

export default GenericSwitch
